import { NgModule } from '@angular/core';
import { NavmenuComponent } from './navmenu/navmenu.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { ConfigurationsModule } from '../configurations/configurations.module';
import { PermissionsService } from '../permissions/services/permissions.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatButtonModule,
        RouterModule,
        ConfigurationsModule
    ],
    declarations: [
        NavmenuComponent
    ],
    exports: [
        NavmenuComponent
    ],
    providers: [
        PermissionsService
    ]
})
export class NavigationModule {}